<template>
  <v-app>
    <v-row class="d-flex align-center justify-center loginContainer">
      <v-col cols="3">
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          class="flex-grow-1 white pa-10"
        >
          <div class="heading primary--text mb-4">
            Đăng nhập
          </div>
          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="E-mail"
            required
          />
          <v-text-field
            v-model="password"
            :rules="passwordRules"
            label="Name"
            type="password"
            required
          />
          <div v-if="error" class="error--text">
            {{ error }}
          </div>
          <v-btn
            color="primary"
            class="signInBtn mt-5 mx-auto"
            :loading="loading"
            @click="signIn"
          >
            ĐĂNG NHẬP
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
  import AuthApi from '@/api/AuthApi'

  export default {
    data: () => ({
      valid: true,
      email: '',
      emailRules: [
        v => !!v || 'Email không được trống',
        v => /.+@.+\..+/.test(v) || 'E-mail phải đúng định dạng',
      ],
      password: '',
      passwordRules: [
        v => !!v || 'Mật khẩu không được trống',
        v => /^(?=.*[\d])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*])[\w!@#$%^&*]{8,}$/.test(v) || 'Mật khẩu phải có ít nhất 8 kí tự và bao gồm chữ hoa, chữ thường, số, ký tự đặc biệt',
      ],
      loading: false,
      error: '',
    }),

    methods: {
      async signIn () {
        this.loading = true
        const res = await AuthApi.signIn({ email: this.email, password: this.password })
        this.loading = false
        const { ok, data } = res
        if (ok) {
          const { accessToken, user: { role } } = data
          if (role === 'admin') {
            localStorage.setItem('accessToken', accessToken)
            this.$router.push('/admin')
          } else if (role === 'psychology' || role === 'listener') {
            localStorage.setItem('accessToken', accessToken)
            this.$router.push('/psychology')
          } else {
            this.error = 'Bạn phải là admin để có thể truy cập vào trang quản trị!'
          }
        } else {
          this.error = 'Email hoặc mật khẩu không đúng!'
        }
      },
    },
  }
</script>

<style lang="sass" scoped>
.loginContainer
  background-image: url('../../assets/login.jpg')
  background-size: cover

  .heading
    font-size: 24px
    font-weight: bold

  .signInBtn
    font-size: 16px
</style>
